<div class="modal-header">
  <h4 class="modal-title pull-left"> Add Privilege</h4>
  <div aria-label="Close" (click)="onCancel()" class="close pull-right">
    <span aria-hidden="true">×</span></div>
</div>

<div class="modal-body">
  <form name="form" #f="ngForm" novalidate>
    <div class="form-group">
      <label class="rbv-label">Privilege</label>
      <input-search placeholder="Search by Name" (valueChange)="searchPrivilege($event)" [provider]="privilegeProvider" [required]="true"></input-search>
    </div>
  </form>
</div>

<div class="modal-footer">
  <button type="button" class="btn btn-rbv default" (click)="onCancel()">Cancel</button>
  <button [disabled]="!f.form.valid" type="button" class="btn btn-rbv" (click)="onAssign()">Assign</button>
</div>
